import { render, staticRenderFns } from "./sliderImg.vue?vue&type=template&id=27d67c30&scoped=true"
import script from "./sliderImg.vue?vue&type=script&lang=js"
export * from "./sliderImg.vue?vue&type=script&lang=js"
import style0 from "./sliderImg.vue?vue&type=style&index=0&id=27d67c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d67c30",
  null
  
)

export default component.exports